// Import constants from the storybook first
import {
  Sections,
  Subsections,
  MEMBER_ACTIONS,
} from '../../../../packages/ui/templates/sign-off/signoff.constants';

import { badgeStyle } from '../../../../packages/ui/atoms/badge';

// Re-export the imported constants
export { Sections, Subsections, MEMBER_ACTIONS };

export const TRANSCRIPTION_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
};

export const STEP_COMPLETION_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
};

export const EVALUATION_STATUS = {
  REJECTED: 'Rejected',
  COMPLETED: 'Completed',
  NOT_STARTED: 'Not started',
  IN_PROGRESS: 'In progress',
  NEEDS_REVIEW: 'For review',
  INCOMPLETE: 'Incomplete',
};

export const evaluationStatusStyle = {
  REJECTED: badgeStyle.CRITICAL,
  COMPLETED: badgeStyle.RESOLVED,
  NOT_STARTED: badgeStyle.UNRELATED,
  IN_PROGRESS: badgeStyle.PRIMARY,
  AI_IN_PROGRESS: badgeStyle.MISREPORTED,
  NEEDS_REVIEW: badgeStyle.MEDIUM,
  INCOMPLETE: badgeStyle.PRIMARY,
};

export const initialStepsStatus = {
  [Sections.SESSION_NOTE]: STEP_COMPLETION_STATUS.NOT_STARTED,
  [Sections.TREATMENT_PLAN]: STEP_COMPLETION_STATUS.NOT_STARTED,
  [Sections.BILLING_REQUIREMENTS]: STEP_COMPLETION_STATUS.NOT_STARTED,
  [Sections.FEEDBACK_FOR_US]: STEP_COMPLETION_STATUS.NOT_STARTED,
  [Sections.FEEDBACK_FOR_YOU]: STEP_COMPLETION_STATUS.NOT_STARTED,
};
